import type { HandleClientError } from '@sveltejs/kit'

import { reportError, startErrorReporting } from '$lib/errorReporting'

// adapter-static: this is the only hooks file, there is no server hook.
export const init = () => {
  startErrorReporting()
}

export const handleError: HandleClientError = ({ error, event, status }) => {
  // SvelteKit's default handleError, which defining this one replaces.
  console.error(error)

  // 404s for unknown routes come through here too; those are not app errors.
  if (status < 500) return

  reportError(error, { routeId: event.route.id, url: event.url.href, status })
}
